module.exports = __webpack_public_path__ + "media/images/athletes/648-4f2170074f4f4d470a969a735cb2b1b5.png";